import ScalablePlayer from '../scalableplayer'
import CryptoJS from 'crypto-js'

var isNull = function (item) {
  if (item === null || item === undefined) {
    return true
  }
  if (
    typeof item === typeof '' &&
    (item === '' || item === 'null' || item === 'undefined')
  ) {
    return true
  }
  return false
}

class Util {}
Util.getStringValue = function (value, defaultValue) {
  if (isNull(defaultValue)) {
    defaultValue = ''
  }

  if (isNull(value)) {
    return defaultValue
  }

  return String(value).replace('$O$', ' ')
}
Util.getDataValue = function (value) {
  if (isNull(value)) return null
  return value
}
Util.getNumberValue = function (value, defaultValue) {
  if (isNull(defaultValue)) {
    defaultValue = -1
  }
  if (isNull(value)) {
    return {
      defaultValue,
    }
  }
  return Number(value)
}
Util.jsonEscape = function (str) {
  let rstr = String(str)
    .replace(/\n/g, '<br>')
    .replace(/＼n/g, '<br>')
    .replace(/\\n/g, '<br>')
    .replace(/\r/g, '')
    .replace(/\t/g, '\\\\t')
  return rstr
}
Util.jsonEscapeBlank = function (str) {
  let rstr = String(str)
    .replace(/\n/g, ' ')
    .replace(/＼n/g, ' ')
    .replace(/\\n/g, ' ')
    .replace(/\r/g, '')
    .replace(/\t/g, '\\\\t')
  return rstr
}
Util.getExtension = function (str) {
  let uA = str.split('?')
  if (uA.length > 0) {
    str = uA[0]
  }

  uA = str.split('.')
  if (uA.length > 0) {
    str = uA[uA.length - 1]
  } else {
    str = ''
  }

  return str
}
Util.getImagePath = function (path, size) {
  if (path === '') {
    return path
  }

  if (path.indexOf('http') === -1 && path.indexOf('https') === -1) {
    path = 'https://' + path
  }
  if (isNull(size)) {
    return path
  }

  let ext = this.getExtension(path)
  if (isNull(ext)) {
    return path
  }
  ext = '.' + ext
  path = path.replace(ext, '_' + size + ext)

  return path
}
Util.getArrayValue = function (data, key) {
  data = this.getDataValue(data)
  if (data == null) {
    return []
  }
  if (isNull(key)) {
    key = 'list'
  }
  let dataArr = this.getDataValue(data[key])
  if (dataArr == null) {
    return []
  }
  return dataArr
}
Util.getBoolValue = function (value) {
  if (isNull(value)) {
    return false
  }
  if (value.toLowerCase() === 'y') {
    return true
  }
  return false
}
Util.getOSInfoStr = function () {
  let ua = navigator.userAgent

  if (ua.indexOf('Windows 10.0') !== -1) return 'Windows 10'
  else if (ua.indexOf('NT 10.0') !== -1) return 'Windows 10'
  else if (ua.indexOf('Windows 8.1') !== -1) return 'Windows 8.1'
  else if (ua.indexOf('NT 6.3') !== -1) return 'Windows 8.1'
  else if (ua.indexOf('Windows 8') !== -1) return 'Windows 8'
  else if (ua.indexOf('NT 6.2') !== -1) return 'Windows 8'
  else if (ua.indexOf('Windows 7') !== -1) return 'Windows 7'
  else if (ua.indexOf('NT 6.1') !== -1) return 'Windows 7'
  else if (ua.indexOf('NT 6.0') !== -1) return 'Windows Vista/Server 2008'
  else if (ua.indexOf('NT 5.2') !== -1) return 'Windows Server 2003'
  else if (ua.indexOf('NT 5.1') !== -1) return 'Windows XP'
  else if (ua.indexOf('NT 5.0') !== -1) return 'Windows 2000'
  else if (ua.indexOf('NT') !== -1) return 'Windows NT'
  else if (ua.indexOf('9x 4.90') !== -1) return 'Windows Me'
  else if (ua.indexOf('Win16') !== -1) return 'Windows 3.x'
  else if (ua.indexOf('Windows') !== -1) return 'Windows'
  else if (ua.indexOf('Linux') !== -1) return 'Linux'
  else if (ua.indexOf('Macintosh') !== -1) return 'Macintosh'
  else if (ua.indexOf('iPad') !== -1) return 'iPad'
  else if (ua.indexOf('iPhone') !== -1) return 'iPhone'
  else if (ua.indexOf('iPod') !== -1) return 'iPod'
  else if (ua.indexOf('Mac OS X') !== -1) return 'Mac OS X'
  else if (ua.indexOf('Android') !== -1) return 'Android'
  else if (ua.indexOf('98') !== -1) return 'Windows 98'
  else if (ua.indexOf('95') !== -1) return 'Windows 95'
  else return 'IDK'
}
Util.getStorage = function (strName) {
  if (typeof localStorage !== 'undefined') {
    try {
      return localStorage.getItem(strName)
    } catch (e) {
      return CookieController.getCookie(strName)
    }
  } else {
    return CookieController.getCookie(strName)
  }
}
Util.setStorage = function (name, value) {
  if (typeof localStorage !== 'undefined') {
    try {
      return localStorage.setItem(name, value)
    } catch (e) {
      return CookieController.setCookie(name, value)
    }
  } else {
    CookieController.setCookie(name, value)
  }
}
Util.intToText = function (n, len) {
  n = Number(n)
  len = Number(len)
  let str = String(n)
  let num = str.length
  if (num < len) {
    for (let i = num; i < len; i++) {
      str = '0' + str
    }
  }

  return str
}
Util.getRandomInt = function (value) {
  let r = Math.random()
  if (r === 1) {
    return value - 1
  }

  return Math.floor(r * value)
}
Util.getYMDHIS = function () {
  let now = new Date()
  let yy = Number(now.getFullYear())
  let mm = Number(now.getMonth()) + 1
  let dd = Number(now.getDate())
  let hh = Number(now.getHours())
  let ii = Number(now.getMinutes())
  let ss = Number(now.getSeconds())

  let requesttime =
    Util.intToText(yy, 4) +
    Util.intToText(mm, 2) +
    Util.intToText(dd, 2) +
    Util.intToText(hh, 2) +
    Util.intToText(ii, 2) +
    Util.intToText(ss, 2)
  return requesttime
}
Util.generateID = function (media) {
  let requesttime = Util.getYMDHIS()
  let uuid = Util.generateRandomString(5) + media + requesttime
  return uuid
}
Util.generateRandomString = function (num) {
  let rstr = ''
  for (let i = 0; i < num; ++i) {
    let s = String(1 + Util.getRandomInt(5))
    rstr = rstr + s
  }
  return rstr
}
Util.getTimeStr = function (t, div, isFull) {
  if (String(t) === 'NaN') {
    t = 0
  }
  if (t < 0) {
    t = 0
  }
  if (div === undefined) {
    div = ':'
  }
  if (isFull === undefined) {
    isFull = false
  }
  t = Number(t)
  let m = t % 3600
  let tim
  if (isFull === true) {
    tim = '00' + div
  } else {
    tim = ''
  }

  if (Math.floor(t / 3600) > 0) {
    tim = Util.intToText(Math.floor(t / 3600), 2) + div
  }
  tim =
    tim +
    Util.intToText(Math.floor(m / 60), 2) +
    div +
    Util.intToText(m % 60, 2)

  return tim
}

class CookieController {}
CookieController.getCookie = function (strName) {
  let strArg = String(strName + '=')
  let nArgLen, nCookieLen, nEnd
  let i = 0
  let j

  nArgLen = strArg.length
  nCookieLen = document.cookie.length

  if (nCookieLen > 0) {
    while (i < nCookieLen) {
      j = i + nArgLen
      if (document.cookie.substring(i, j) === strArg) {
        nEnd = document.cookie.indexOf(';', j)
        if (nEnd === -1) nEnd = document.cookie.length
        return unescape(document.cookie.substring(j, nEnd))
      }
      i = document.cookie.indexOf(' ', i) + 1
      if (i === 0) {
        break
      }
    }
  }

  return ''
}
CookieController.deleteCookie = function (name, path, domain) {
  if (this.getCookie(name)) {
    document.cookie =
      name +
      '=' +
      (path ? ';path=' + path : '') +
      (domain ? ';domain=' + domain : '') +
      ';expires=Thu, 01 Jan 1970 00:00:01 GMT'
  }
}

CookieController.setCookie = function (
  name,
  value,
  path,
  domain,
  expires,
  secure,
) {
  if (secure === undefined) {
    secure = false
  }

  if (String(typeof expires) === 'number') {
    let days = new Date()
    days.setDate(days.getDate() + expires)
    expires = days
  } else {
    expires = null
  }

  if (path === undefined || path === '') {
    path = null
  }

  if (domain === undefined || domain === '') {
    domain = null
  }

  document.cookie =
    name +
    '=' +
    escape(String(value)) +
    (expires === null ? '' : '; expires=' + expires.toUTCString()) +
    (path === null ? '' : '; path=' + path) +
    (domain === null ? '' : '; domain=' + domain) +
    (secure === true ? '; secure' : '')
}

class CookieParser {}
CookieParser.getCookieInfo = function (key) {
  return (
    decodeURIComponent(
      document.cookie.replace(
        new RegExp(
          '(?:(?:^|.*;)\\s*' +
            encodeURIComponent(key).replace(/[-.+*]/g, '\\$&') +
            '\\s*\\=\\s*([^;]*).*$)|^.*$',
        ),
        '$1',
      ),
    ) || null
  )
}

CookieParser.isVerifiedAdultUser = function () {
  let keyVerifiedAdult = 'verifiedAdult'
  return this.getCookieInfo(keyVerifiedAdult) === '1'
}

CookieParser.needAdultPinNumber = function () {
  let keyVerifiedAdult = 'adult-settings'
  return this.getCookieInfo(keyVerifiedAdult) === 'L'
}

CookieParser.hasCredential = function () {
  let csInfo = JSON.parse(this.getCookieInfo('cs'))
  return (csInfo ? csInfo['credential'] : 'none') !== 'none'
}

CookieParser.isWavveOn = function () {
  let pz = JSON.parse(this.getCookieInfo('pz'))
  if (pz !== null && pz !== undefined && pz.isPooqzone !== undefined) {
    return pz.isPooqzone
  }
  return false
}

var FUNCTION_BTN_CODE = {
  verify: '실명인증',
  eventpurchase: '이벤트 구매하기',
  login: '로그인',
  join: '회원가입',
  quality: '화질변경',
  purchase: '구매하기',
  cancel: '취소',
  retry: '재시도',
  confirm: '확인',
}

class UserInfoObject {
  constructor() {
    this.isView = false
    this.title = ''
    this.msg = ''
    this.btns = []
  }

  setData(data, key, isPost, mode) {
    if (isNull(isPost)) {
      isPost = false
    }

    this.msg = Util.jsonEscape(Util.getStringValue(data[key + 'msg']))
    this.title = Util.getStringValue(data[key + 'title'])
    let btnStr = Util.getStringValue(data[key + 'btn'])
    let btnKeys = btnStr.split(',')
    for (let i = 0; i < btnKeys.length; i++) {
      let code = FUNCTION_BTN_CODE[btnKeys[i]]
      if (mode === ScalablePlayer.playerMode.POPUP) {
        switch (code) {
          case FUNCTION_BTN_CODE.verify:
          case FUNCTION_BTN_CODE.eventpurchase:
          case FUNCTION_BTN_CODE.login:
          case FUNCTION_BTN_CODE.join:
          case FUNCTION_BTN_CODE.purchase:
            code = null
        }
      }
      if (!isNull(code)) {
        this.btns.push(code)
      }
    }

    if (isPost === false) {
      return
    }

    if (this.btns.length < 1) {
      this.btns.push(FUNCTION_BTN_CODE.confirm)
    }
  }
}

class AdRequestLogs {
  constructor() {
    this.continue = true
    this.start = false
    this.firstQuartile = false
    this.midPoint = false
    this.thirdQuartile = false
    this.fifteenSeconds = false
    this.thirtySeconds = false
    this.complete = false
  }
}

class AdRequestObject {
  constructor() {
    this.url = ''
    this.totalCount = 1
    this.count = 1
    this.tid = String(CryptoJS.MD5(Util.generateID('POOQ')))
    this.logapiversion = '2.0'
    this.adapiversion = '2.5'
    this.videologUrl = ''
    this.isActive = false
    this.optionnalData = null
  }
}

class QualityObject {
  constructor() {
    this.name = ''
    this.ID = ''
    this.marks = ''
    this.filesize = ''
  }
}

class LiveEpgsChannelObject {
  constructor() {
    this.schduleID = ''
    this.programID = ''
    this.title = ''
    this.image = ''
    this.genre = ''
    this.startTime = ''
    this.endTime = ''
    this.isTimemachine = false
    this.isLicense = ''
    this.marks = ''
    this.targetAge = ''
    this.isSteam = ''
    this.isAlarm = ''
  }
}

class PlayInfoObj {
  /**
   *
   * @param type
   * @param contentID
   * @param resolution {string} max resolution (Ex. "1080p")
   * @param isDVR
   * @param isAutoPlay
   * @constructor
   */
  constructor(type, contentID, mode, resolution, isDVR, isAutoPlay, gameID) {
    if (isNull(contentID)) {
      contentID = ''
    }
    if (isNull(resolution)) {
      if (!isNull(mode)) {
        switch (mode) {
          case ScalablePlayer.playerMode.INSTANT:
            resolution = '720p'
            break
          default:
            // resolution = DataManager.getInstance().getSetupValue(SHARED_KEY.QUALITY);
            break
        }
      }
    }
    if (isNull(isDVR)) {
      isDVR = false
    }
    if (isNull(isAutoPlay)) {
      isAutoPlay = false
    }
    this.programID = ''
    this.contentID = contentID
    this.playerMode = mode
    this.resolution = resolution
    this.qualities = []
    this.quality = ''
    this.isRadio = false
    this.isRadioChannel = false
    this.type = type
    this.isAutoPlay = isAutoPlay
    this.gameID = gameID
    this.initTime = -1
    this.play = ''
    this.authType = ''
    this.playUrl = ''
    this.etcUrl = ''
    this.awsCookie = ''
    this.issue = ''
    this.playID = ''
    this.chargedType = ''
    this.priceType = ''
    this.concurrencyGroup = ''
    this.playTime = 0
    this.onAirVod = ''
    this.previewTime = 0
    this.prerollRequestObject = null
    this.prerollRequestLogs = null
    this.postScreen = ''
    this.adObject = null
    this.isVTT = false
    this.vttPath = ''
    this.isDVR = isDVR
    this.isSignedCookie = false
    this.isDRM = false
    this.drmType = DRM_TYPE.NONE
    this.drmHeader = null
    this.drmHost = ''
    this.flags = null
    this.query = ''
    this.isPreview = false
    this.postData = null
    this.previewData = null
    this.marketingData = null
    this.nextTriggerSeconds = 60
    this.autoNextTrigger = true
    this.isAllow = true
    this.isSeekAble = true
    this.isShareAble = !(
      this.type === PlayInfoObj.PLAY_TYPE.AD ||
      this.type === PlayInfoObj.PLAY_TYPE.QVOD ||
      // DataManager.getInstance().mode == PLAYER_MODE.CUSTOM ||
      // DataManager.getInstance().mode == PLAYER_MODE.POPUP ||
      CookieParser.isWavveOn()
    )
    this.extraItem = null
    this.bookmarkExtra = null

    this.cookieOption = {
      domain: '.wavve.com',
      path: '/',
    }

    PlayInfoObj.setDVR(isDVR)
  }

  setMaxResolution(resolution) {
    this.resolution = resolution
  }

  getMaxResolution() {
    if (isNull(this.resolution)) {
      return null
    }
    return this.resolution
  }

  clone(minime) {
    for (let key in this) {
      minime[key] = this[key]
    }
    return minime
  }

  update(overrideData) {
    if (!overrideData) {
      return
    }

    for (let key in overrideData) {
      if (overrideData[key] !== null && overrideData[key] !== undefined) {
        this[key] = overrideData[key]
        // console.log("set key : " + key+ " : " +  this[key]);
      }
    }
    return this
  }

  hasPrerolls() {
    if (isNull(this.prerollRequestObject)) {
      return false
    }
    if (isNull(this.prerollRequestObject.url)) {
      return false
    }
    return true
  }

  /* setAdData (data) {
        this.vodUrl = data.content_url
        this.vodUrl = this.vodUrl.replace(/https:/g, 'http:')
        this.adObject = new AdObject()
        this.adObject.setData(data)
        this.isSeekAble = false
    } */

  removeCookie(cookie, domain, path) {
    if (isNull(cookie)) {
      return false
    }

    let cookies = cookie.split(';')
    let kv
    for (let i = 0; i < cookies.length; ++i) {
      kv = cookies[i].split('=')
      if (kv.length === 2) {
        CookieController.deleteCookie(kv[0], path, domain)
      }
    }

    return true
  }

  addCookie(cookie, domain, path) {
    if (isNull(cookie)) {
      return false
    }

    let cookies = cookie.split(';')
    let kv
    for (let i = 0; i < cookies.length; ++i) {
      kv = cookies[i].split('=')
      if (kv.length === 2) {
        CookieController.setCookie(kv[0], kv[1], path, domain)
      }
    }

    return true
  }

  setData(data) {
    this.query = ''
    this.qualities = this.getQualities(data.qualities)
    this.play = Util.getStringValue(data.play)
    this.authType = Util.getStringValue(data.authtype)
    this.playUrl =
      !this.isDVR || this.type === PlayInfoObj.PLAY_TYPE.BASEBALL_LIVE
        ? Util.getStringValue(data.playurl)
        : Util.getStringValue(data.liveurl)
    this.etcUrl = Util.getStringValue(data.etcurl)

    this.removeCookie(
      this.awsCookie,
      this.cookieOption.domain,
      this.cookieOption.path,
    )
    this.awsCookie = Util.getStringValue(data.awscookie)
    this.addCookie(
      this.awsCookie,
      this.cookieOption.domain,
      this.cookieOption.path,
    )

    this.issue = Util.getStringValue(data.issue)
    this.playID = Util.getStringValue(data.playid, 'none')
    this.quality = Util.getStringValue(data.quality)
    this.resolution = this.quality

    this.chargedType = Util.getStringValue(data.chargedtype)
    this.priceType = Util.getStringValue(data.pricetype)
    this.concurrencyGroup = Util.getStringValue(data.concurrencygroup)
    this.playTime = Util.getNumberValue(data.playtime)
    this.onAirVod = Util.getStringValue(data.onairvod)
    this.drmType = Util.getStringValue(data.drmtype)
    this.postScreen = Util.getStringValue(data.postscreen)
    this.drm = Util.getStringValue(data.drm)
    this.previewTime = Util.getNumberValue(data.previewtime, 60)
    this.nextTriggerSeconds = Util.getNumberValue(data.nexttriggerseconds, 60)
    this.extraItem = Util.getStringValue(data.extraitem)
    this.bookmarkExtra = data.bookmarkextra

    let prerollAD = Util.getDataValue(data.prerollad)

    if (prerollAD) {
      this.prerollRequestObject = new AdRequestObject()
      this.prerollRequestObject.count = Util.getNumberValue(
        prerollAD.playcount,
        1,
      )
      this.prerollRequestObject.totalCount = this.prerollRequestObject.count
      this.prerollRequestObject.adapiversion = Util.getStringValue(
        prerollAD.adapiversion,
      )
      this.prerollRequestObject.url = Util.getStringValue(prerollAD.url)
      this.prerollRequestObject.logapiversion = Util.getStringValue(
        prerollAD.logapiversion,
      )
      this.prerollRequestObject.videologUrl = Util.getStringValue(
        prerollAD.videologUrl,
      )
      this.prerollRequestObject.optionnalData = prerollAD

      this.prerollRequestObject.url = this.prerollRequestObject.url.replace(
        /http:/g,
        'https:',
      )
      this.prerollRequestObject.videologUrl =
        this.prerollRequestObject.videologUrl.replace(/http:/g, 'https:')

      this.prerollRequestLogs = new AdRequestLogs()
    }
    this.isVTT = this.etcUrl !== ''
    // if (util.playerType == PLAYER_TEC_TYPE.FLASH)  this.isVTT = false;
    this.vttPath = this.etcUrl + 'thumbnail.vtt'

    this.isDRM = this.drmType !== ''
    let drm = Util.getDataValue(data.drm)
    if (drm != null) {
      this.drmHeader = Util.getStringValue(drm.customdata)
      this.drmHost = Util.getStringValue(drm.drmhost)
    }
    this.vodUrl = this.playUrl

    this.isRadio = this.quality === '100p'
    let play = Util.getStringValue(data.play)
    this.isPreview = play === 'p'
    this.isAllow = play === 'y'

    if (data.preview) {
      this.postData = new UserInfoObject()
      this.previewData = new UserInfoObject()
      this.postData.setData(data.preview, 'exit', true)
      this.previewData.setData(data.preview, 'preview', false)

      if (this.postData.msg === '') {
        this.postData = null
      }
      if (this.previewData.msg === '') {
        this.previewData = null
      }
    }

    if (data.marketing) {
      this.marketingData = new UserInfoObject()
      this.marketingData.setData(data.marketing, 'marketing', false)

      if (this.marketingData.msg === '') {
        this.marketingData = null
      }
    } else {
      this.marketingData = null
    }

    this.autoNextTrigger = this.postData == null
    this.isSeekAble = !(
      (this.type === PlayInfoObj.PLAY_TYPE.LIVE ||
        this.type === PlayInfoObj.PLAY_TYPE.BASEBALL_LIVE) &&
      this.isDVR === false
    )
  }

  getQualities(data) {
    let qualities = []
    let datas = Util.getArrayValue(data)
    this.isRadioChannel = true
    for (let i = 0; i < datas.length; ++i) {
      let d = datas[i]
      let quality = new QualityObject()
      quality.name = Util.getStringValue(d.name)
      quality.ID = Util.getStringValue(d.id)
      quality.marks = Util.getStringValue(d.marks)
      quality.filesize = Util.getStringValue(d.filesize)
      qualities[i] = quality

      if (quality.ID !== '100p') {
        this.isRadioChannel = false
      }
    }
    return qualities
  }

  getChannelType() {
    let chType = ''
    switch (this.type) {
      case PlayInfoObj.PLAY_TYPE.LIVE:
        chType = 'L'
        break
      case PlayInfoObj.PLAY_TYPE.CLIP:
        chType = 'C'
        break
      case PlayInfoObj.PLAY_TYPE.MOVIE:
        chType = 'M'
        break
      case PlayInfoObj.PLAY_TYPE.BASEBALL_LIVE:
      case PlayInfoObj.PLAY_TYPE.BASEBALL_HIGHLIGHT:
        chType = 'E'
        break
      default:
        chType = 'V'
        break
    }
    return chType
  }

  // For Bookmarks
  getItemType() {
    let id = ''
    switch (this.resolution) {
      case '100p':
        id = '100'
        break
      case '500':
      case '360p':
        id = '1'
        break
      case '700':
        id = '2'
        break
      case '1000':
      case '480p':
        id = '3'
        break
      case '2000':
      case '720p':
        id = '4'
        break
      case '5000':
      case '1080p':
        id = '9'
        break
      case '2160p':
        id = '21'
        break
    }
    return id
  }
}
PlayInfoObj.setDVR = function (_isDVR) {
  if (isNull(_isDVR)) {
    _isDVR = false
  }
  this.isDVR = _isDVR
  if (this.isDVR === true) {
    this.flags = [
      { t: 0, v: '-60' },
      { t: 600, v: '-50' },
      { t: 1200, v: '-40' },
      { t: 1800, v: '-30' },
      { t: 2400, v: '-20' },
      { t: 3000, v: '-10' },
    ]
  } else {
    this.flags = null
  }
}
PlayInfoObj.PLAY_TYPE = {
  NONE: 'none',
  LIVE: 'live',
  VOD: 'vod',
  AD: 'ad',
  CLIP: 'clip',
  MOVIE: 'movie',
  QVOD: 'onairvod',
  PROGRAM: 'program',
  BASEBALL_LIVE: 'baseballlive',
  BASEBALL_HIGHLIGHT: 'baseballhighlight',
}

var DRM_TYPE = {
  NONE: 'none',
  WIDEVINE_CLASIC: 'wc',
  WIDEVINE: 'wm',
  PLAY_READY: 'pr',
  FAIR_PLAY: 'fp',
}

class MetaObj {
  constructor() {
    this.updateKey = Util.generateID('Meta')
    this.type = ''
    this.channelID = ''
    this.channelTitle = ''
    this.programID = ''
    this.programTitle = ''
    this.title = ''
    this.channelColor = ''
    this.image = ''
    this.tvImage = ''
    this.streamType = ''
    this.price = ''
    this.genreText = ''
    this.genreValue = ''
    this.startTime = ''
    this.endTime = ''
    this.playRatio = ''
    this.isTimemachine = false
    this.isLicense = true
    this.marks = ''
    this.targetAge = ''
    this.isLogin = null
    this.isAdult = null
    this.needAdultPin = null
    this.episodeNumber = ''
    this.releaseDate = ''
    this.releaseWeekDay = ''
    this.episodeTitle = ''
    this.playTime = 0
    this.isHomeShopping = false
    this.liveEpgsChannelList = []
    this.originTitle = ''
    this.reReleaseDate = ''
    this.isSteam = false
    this.isAlarm = false
    this.isDownloadAble = false
    this.synopsis = ''
    this.cpid = ''
    this.cpname = ''
    this.viewTime = -1
    this.viewRatio = ''
    this.rating = ''
    this.country = ''
    this.deliveRationInfo = ''

    this.events = []
    this.directors = []
    this.actors = []
    this.tags = []
    this.genres = []
    this.drms = DRM_TYPE.NONE

    this.programSynopsis = ''
    this.programImage = ''
    this.genreText = ''
    this.genreValue = ''
    this.liveChannel = ''
    this.prevEpisode = null
    this.nextEpisode = null

    this.viewTitle = ''
    this.initImage = ''
    this.contentID = ''

    this.playStartTime = -1
    this.playEndTime = -1
    this.playUpdateTime = -1
    this.lastPlayCheckTime = -1
    this.recommendID = ''
    this.recommendType = ''
    this.contentType = ''
    this.linkType = ''

    this.isWavveOn = CookieParser.isWavveOn() // DataManager.getInstance().info.pooqzoneType == "none" || DataManager.getInstance().info.pooqzoneType == "") ? false : true;

    this.emergencyFinishTime = null
  }

  init() {}

  getInitImage() {
    return this.programImage !== '' ? this.programImage : this.image
  }

  getTitle() {
    let title = this.title
    if (this.type === PlayInfoObj.PLAY_TYPE.LIVE) {
      title = this.channelTitle === '' ? title : this.channelTitle + ' ' + title
    } else if (this.type === PlayInfoObj.PLAY_TYPE.BASEBALL_HIGHLIGHT) {
      title = this.episodeTitle === '' ? title : this.episodeTitle
    } else {
      title =
        this.episodeNumber === '' || this.episodeNumber === '0'
          ? title
          : title + ' ' + this.episodeNumber + '회'
    }
    return title
  }

  /* getEpisode (data) {
        data = Util.getDataValue(data)
        if (data == null) {
            return null
        }
        let episode = new EpisodeObject()
        episode.contentID = Util.getStringValue(data.contentid)
        if (episode.contentID === '') {
            return null
        }
        episode.episodeNumber = Util.getStringValue(data.episodenumber)
        episode.releaseDate = Util.getStringValue(data.releasedate)
        episode.releaseWeekday = Util.getStringValue(data.releaseweekday)
        episode.image = Util.getStringValue(data.image)
        episode.image = Util.getImagePath(episode.image)
        episode.init()
        return episode
    } */

  /* setEvents (data) {
        this.events = []
        let dataArr = Util.getArrayValue(data)
        for (let i = 0; i < dataArr.length; i++) {
            let d = dataArr[i]
            let event = new EventObject()
            event.name = Util.getStringValue(d.name)
            event.ID = Util.getStringValue(d.id)
            event.marks = Util.getStringValue(d.marks)
            event.filesize = Util.getStringValue(d.filesize)
            this.events.push(event)
        }
    } */

  setLiveEpgsChannelList(data) {
    this.liveEpgsChannelList = []
    let datas = Util.getArrayValue(data)

    for (let i = 0; i < datas.length; ++i) {
      let d = datas[i]
      let channel = new LiveEpgsChannelObject()
      channel.schduleID = Util.getStringValue(d.schduleid)
      channel.programID = Util.getStringValue(d.programid)
      channel.title = Util.getStringValue(d.title)
      channel.image = Util.getStringValue(d.image)
      channel.genre = Util.getStringValue(d.genre)
      channel.startTime = Util.getStringValue(d.starttime)
      channel.endTime = Util.getStringValue(d.endtime)
      channel.isTimemachine = Util.getBoolValue(d.timemachine)
      channel.isLicense = Util.getBoolValue(d.license)
      channel.marks = Util.getStringValue(d.marks)
      channel.targetAge = Util.getStringValue(d.targetage)
      channel.isSteam = Util.getBoolValue(d.zzim)
      channel.isAlarm = Util.getBoolValue(d.alarm)
      this.liveEpgsChannelList.push(channel)
    }
  }

  setData(data, type, mode) {
    if (type === PlayInfoObj.PLAY_TYPE.BASEBALL_LIVE) {
      return this.setBaseballLiveMetaData(data)
    }

    this.type = type
    this.title = Util.getStringValue(data.title)
    this.channelID = Util.getStringValue(data.channelid)
    this.programID = Util.getStringValue(data.programid)
    this.episodeTitle = Util.getStringValue(data.episodetitle)
    this.episodeNumber = Util.getStringValue(data.episodenumber)
    this.image = Util.getStringValue(data.image)
    this.releaseDate = Util.getStringValue(data.releasedate)
    this.releaseWeekDay = Util.getStringValue(data.releaseweekday)
    this.price = Util.getStringValue(data.price)
    this.cpid = Util.getStringValue(data.cpid)
    this.targetAge = Util.getStringValue(data.targetage, '0')
    if (this.targetAge >= 18) {
      let cookieParser = new CookieParser()
      this.isAdult = cookieParser.isVerifiedAdultUser()
      this.isLogin = cookieParser.hasCredential()
      this.needAdultPin = cookieParser.needAdultPinNumber()
    }
    this.marks = Util.getStringValue(data.marks)
    this.playTime = Util.getNumberValue(data.playtime)
    this.playRatio = Util.getStringValue(data.playratio)
    this.viewTime = Util.getNumberValue(data.viewtime)
    this.viewRatio = Util.getStringValue(data.viewratio)
    this.streamType = Util.getStringValue(data.type, 'video')
    this.isSteam = Util.getBoolValue(data.zzim)
    this.isAlarm = Util.getBoolValue(data.alarm)
    this.isDownloadAble =
      mode === ScalablePlayer.playerMode.POPUP ||
      mode === ScalablePlayer.playerMode.CUSTOM ||
      this.isWavveOn
        ? false
        : Util.getBoolValue(data.downloadable)
    this.tags = Util.getArrayValue(data.tags)
    this.actors = Util.getArrayValue(data.actors)
    this.synopsis = Util.getStringValue(data.synopsis)
    this.contentType = this.type

    switch (this.type) {
      case PlayInfoObj.PLAY_TYPE.LIVE:
        this.title = Util.getStringValue(data.title)
        this.channelTitle = Util.getStringValue(data.channelname)
        this.channelColor = Util.getStringValue(data.channelcolor)
        this.tvImage = Util.getStringValue(data.tvimage)
        this.genreText = Util.getStringValue(data.genretext)
        this.genreValue = Util.getStringValue(data.genrevalue)
        this.startTime = Util.getStringValue(data.starttime)
        this.endTime = Util.getStringValue(data.endtime)
        // EmergencyMode에서 endTime이 주어지지 않을 수 있다.
        /* if (jarvis.lib.emergencyQuery !== "") {
                    this.setEndTimeByStartTime(jarvis.lib.emergencyContentDurationMin);
                } */

        this.isTimemachine = Util.getBoolValue(data.timemachine)
        this.isLicense = Util.getBoolValue(data.license)
        this.isHomeShopping = Util.getBoolValue(data.homeshopping)
        this.setLiveEpgsChannelList(data.liveepgschannellist)
        this.findUpdateTime()

        this.recommendID = this.programID
        this.recommendType = PlayInfoObj.PLAY_TYPE.PROGRAM
        break

      case PlayInfoObj.PLAY_TYPE.MOVIE:
        this.title = Util.getStringValue(data.title)
        this.originTitle = Util.getStringValue(data.origintitle)
        this.reReleaseDate = Util.getStringValue(data.rereleasedate)

        this.cpname = Util.getStringValue(data.cpname)
        this.rating = Util.getStringValue(data.rating)
        this.country = Util.getStringValue(data.country)
        this.deliveRationInfo = Util.getStringValue(data.deliverationinfo)
        // this.setEvents(data.event)
        this.directors = Util.getArrayValue(data.directors)
        this.genres = Util.getArrayValue(data.genre)
        this.drms = Util.getStringValue(data.drms, DRM_TYPE.NONE)
        this.contentID = Util.getStringValue(data.movieid)
        this.recommendID = this.contentID
        this.recommendType = PlayInfoObj.PLAY_TYPE.MOVIE
        break

      case PlayInfoObj.PLAY_TYPE.CLIP:
        this.title = Util.getStringValue(data.cliptitle)
        this.programTitle = Util.getStringValue(data.programtitle)
        this.channelTitle = Util.getStringValue(data.channeltitle)
        this.contentID = Util.getStringValue(data.contentid)
        this.linkType = Util.getStringValue(data.linktype)

        this.recommendID = this.programID
        this.recommendType = PlayInfoObj.PLAY_TYPE.PROGRAM
        break

      default:
        this.title = Util.getStringValue(data.programtitle)
        this.channelTitle = Util.getStringValue(data.channelname)
        this.releaseWeekDay = Util.getStringValue(data.programreleaseweekday)
        this.startTime = Util.getStringValue(data.programstarttime)
        this.endTime = Util.getStringValue(data.programendtime)
        this.programSynopsis = Util.getStringValue(data.programsynopsis)
        this.programImage = Util.getStringValue(data.programimage)
        this.genreText = Util.getStringValue(data.genretext)
        this.genreValue = Util.getStringValue(data.genrevalue)
        this.drms = Util.getStringValue(data.drms, DRM_TYPE.NONE)
        this.liveChannel = Util.getStringValue(data.livechannel)
        // this.prevEpisode = this.getEpisode(data.prevepisode)
        // this.nextEpisode = this.getEpisode(data.nextepisode)
        this.contentID = Util.getStringValue(data.contentid)

        this.recommendID = this.programID
        this.recommendType = PlayInfoObj.PLAY_TYPE.PROGRAM
        break
    }

    this.programImage = Util.getImagePath(this.programImage)
    this.image = Util.getImagePath(this.image)
    this.tvImage = Util.getImagePath(this.tvImage)

    this.viewTitle = this.getTitle()
    this.initImage = this.getInitImage()
  }

  setBaseballLiveMetaData(data) {
    let i = 0
    let tempBaseballDurationMin = 180

    let grids = data.grids
    if (typeof grids !== typeof []) {
      return null
    }

    let otherStadiumStatus = null
    let gridsLen = grids.length
    for (i = gridsLen - 1; i >= 0; i++) {
      if (grids[i].cardTitle === '타 구장 현황') {
        otherStadiumStatus = grids[i]
        break
      }
    }
    if (otherStadiumStatus === null) {
      return null
    }

    let gridsOfOtherStadiumStatus = otherStadiumStatus.grids
    if (typeof gridsOfOtherStadiumStatus !== typeof []) {
      return null
    }

    let homeStadium = null
    let gridsLenOfOtherStadiumStatus = gridsOfOtherStadiumStatus.length
    for (i = gridsLenOfOtherStadiumStatus - 1; i >= 0; i--) {
      if (gridsOfOtherStadiumStatus[i].HOMESTADIUM !== undefined) {
        if (
          typeof gridsOfOtherStadiumStatus[i].HOMESTADIUM === typeof [] &&
          gridsOfOtherStadiumStatus[i].HOMESTADIUM.length > 0
        ) {
          homeStadium = gridsOfOtherStadiumStatus[i].HOMESTADIUM[0]
        } else {
          homeStadium = gridsOfOtherStadiumStatus[i].HOMESTADIUM
        }
        break
      }
    }

    if (homeStadium === null || homeStadium === undefined) {
      return null
    }

    let leftTeamName = Util.getStringValue(homeStadium.leftTeamName)
    let rightTeamName = Util.getStringValue(homeStadium.rightTeamName)
    let gamePlace = Util.getStringValue(homeStadium.gamePlace)
    if (leftTeamName !== '' && rightTeamName !== '') {
      this.viewTitle = leftTeamName + ' VS ' + rightTeamName
      if (gamePlace !== '') {
        this.viewTitle = this.viewTitle + ' (' + gamePlace + ')'
      }
    } else {
      this.viewTitle = ''
    }
    let gameTime = Util.getStringValue(homeStadium.gameTime)
    if (gameTime.length === 4) {
      this.startTime = gameTime.substring(0, 2) + ':' + gameTime.substring(2, 4)
      this.setEndTimeByStartTime(tempBaseballDurationMin)
      this.findUpdateTime()
    }
    this.isBaseballLiveEnd = Util.getStringValue(homeStadium.state) !== 'LIVE'
    if (this.isBaseballLiveEnd === true) {
      this.baseballLiveFinishUserInfo = new UserInfoObject()
      this.baseballLiveFinishUserInfo.setData(
        {
          exitmsg: '해당 경기는 종료되었습니다.',
          exittitle: '알림',
        },
        'exit',
        true,
      )
    }
    this.isTimemachine = true
    this.lastPlayCheckTime = new Date().getTime()
    this.playUpdateTime = 10000
  }

  findUpdateTime() {
    let now = new Date()
    let ct = now.getTime()

    let sdate = this.getTimeDate(this.startTime)
    let edate = this.getTimeDate(this.endTime, sdate.getHours())

    let st = sdate.getTime()
    let et = edate.getTime()

    if (st >= et) {
      edate = this.getNextTimeDate(edate)
      et = edate.getTime()
    }
    this.playCurrentTime = ct
    this.playStartTime = st
    this.playEndTime = et
    this.playUpdateTime = et + Math.floor(Math.random() * 60 * 5 * 1000)
  }

  getTimeDate(hhmm) {
    let now = new Date()
    let cy = now.getFullYear()
    let cm = now.getMonth()
    let cd = now.getDate()

    let tA = hhmm.split(':')
    if (tA.length !== 2) {
      return new Date()
    }

    let h = Number(tA[0])
    let m = Number(tA[1])
    return new Date(cy, cm, cd, h, m, 0, 0)
  }

  getNextTimeDate(date) {
    let nextDate = new Date()
    nextDate.setTime(date.getTime() + 86400000) // 1000*60*60*24
    return nextDate
  }

  setEndTimeByStartTime(duration) {
    if (isNull(this.endTime)) {
      if (
        !isNull(this.startTime) &&
        typeof this.startTime === typeof '' &&
        this.startTime.length > 4
      ) {
        let splitStartTime = this.startTime.split(':')
        if (splitStartTime.length > 0) {
          let startHour = Number(splitStartTime[0])
          let endHour = (startHour + duration / 60) % 24
          let startMin = Number(splitStartTime[1])
          let endMin = startMin + (duration % 60)
          if (endMin >= 60) {
            endHour += endMin / 60
          }
          if (endHour > 24) {
            endHour %= 24
          }
          if (endHour < 10) {
            endHour = '0' + endHour
          }
          if (endMin < 10) {
            endMin = '0' + endMin
          }
          this.endTime = endHour + ':' + endMin
        }
      }
    }

    /* if (jarvis.lib.emergencyQuery !== "") {
            this.emergencyFinishTime = this.getTimeDate(this.endTime);
            if (jarvis.lib.emergencyContentMaintainAfterMin > 0) {
                this.emergencyFinishTime.setMinutes(this.emergencyFinishTime.getMinutes() + jarvis.lib.emergencyContentMaintainAfterMin);
            }

            this.emergencyFinishUserInfo = new UserInfoObject();
            this.emergencyFinishUserInfo.setData({
                exitmsg: jarvis.lib.emergencyContentFinishGuide,
                exittitle: "알림"
            }, "exit", true);
        } */
  }
}

var SHARED_KEY = {
  QUALITY: 'quality',
  LAST_PLAY_ID: 'lastPlayID',
  LAST_GUID: 'lastGUID',
  AUTO_PLAY: 'autoPlay',
  PLAY_RATE: 'playRate',
  SCREEN_RATIO: 'screenRatio',
  UID_COOKIE: 'uidCookie',
  INIT_USER: 'initUser',
  TM_INFO: 'tmInfo',
  AUTO_PLAY_INFO: 'autoPlayInfo',
  I_WANT_FLASH: 'iWantFlash',
  PLAYER_TYPE: 'playerType',
  USER_NO: 'userNo',
  CREDENTIAL: 'credential',
}

class DataInfo {
  constructor() {
    this.API_CREDENTIAL_KEY = 'E5F3E0D30947AA5440556471321BB6D9'
    this.SMR_ENC_KEY = '1d9b87e47123f4b4'
    this.SHARE_KEY = 'SHARE_KEY'
    this.credentialKey = 'none'
    this.userInfo = null
    this.GUID = ''
    this.clientIP = '127.0.0.1'
    this.userID = ''
    this.userNo = ''
    this.profileID = ''
    this.shared = null
    this.lastPlayID = ''
    this.pooqzoneType = 'none'
    this.osVer = Util.getOSInfoStr()
    this.device = 'pc'
    // this.isABR = (typeof IS_ABR === 'undefined') ? 'y' : IS_ABR
    this.browser = ScalablePlayer.getBrowser()
    this.deviceName4Applog = this.browser.name + this.browser.version
    this.deviceName4Bookmark =
      this.browser.name.toLowerCase() + '_' + this.browser.version.toLowerCase()
    this.drmType = this.getDRMType()
    this.prevSendBookMarkTime = -1
    this.adultVerification = null
    this.isSupportEC3 = this.checkSupportEAC3()
    this.isSupportHEVC = this.checkSupportHEVC()
  }

  init() {
    this.shared = this.getSetupData()
    this.lastPlayID = this.getSetupValue(SHARED_KEY.LAST_PLAY_ID)
    this.GUID = this.getSetupValue(SHARED_KEY.LAST_GUID)
    this.setCredential()
    // alert(this.GUID);
    return this
  }

  setCredential() {
    var csInfo = JSON.parse(CookieParser.getCookieInfo('cs'))
    this.credentialKey = csInfo ? csInfo['credential'] : 'none'
  }

  setSenderUserInfo(userInfo) {
    this.lastPlayID = userInfo.lastPlayID
    this.setUserInfo(userInfo)
  }

  getUserInfo() {
    return this.userInfo
  }

  setUserInfo(userInfo) {
    if (isNull(userInfo)) {
      return
    }
    this.userInfo = userInfo
    this.credentialKey = userInfo.credentialKey
      ? userInfo.credentialKey
      : this.credentialKey
    this.GUID = userInfo.GUID ? userInfo.GUID : this.GUID
    this.clientIP = userInfo.clientIP ? userInfo.clientIP : this.clientIP
    this.userID = userInfo.userID ? userInfo.userID : this.userID
    if (userInfo.profileID === 'none') {
      userInfo.profileID = '0'
    }
    this.profileID = userInfo.profileID ? userInfo.profileID : this.profileID
    this.pooqzoneType = userInfo.pooqzoneType
      ? userInfo.pooqzoneType
      : this.pooqzoneType
    this.userNo = userInfo.userNo
    if (this.userNo === 'none') {
      let padLeft = function (ip) {
        return ('000' + ip).slice(-3)
      }
      let getDummyUserNo = function () {
        var ip = localStorage.getItem('ip')
        return ip === null
          ? '9000000000'
          : '9' + ip.split('.').map(padLeft).join('')
      }
      this.userNo = getDummyUserNo()
    }
    if (userInfo.adultverification) {
      this.setAdultVerification(userInfo.adultverification)
    }
  }

  isLogin() {
    return this.credentialKey !== 'none'
  }

  getSetupData() {
    let json = null
    let jsonStr = Util.getStorage(this.SHARE_KEY)
    if (isNull(jsonStr)) {
      json = {}
      json[SHARED_KEY.QUALITY] = '1080p'
      json[SHARED_KEY.LAST_PLAY_ID] = 'none'
      json[SHARED_KEY.AUTO_PLAY] = 'Y'
      json[SHARED_KEY.PLAY_RATE] = '1'
      json[SHARED_KEY.SCREEN_RATIO] = 'contain'
      json[SHARED_KEY.INIT_USER] = 'Y'
      json[SHARED_KEY.TM_INFO] = 'Y'
      json[SHARED_KEY.AUTO_PLAY_INFO] = 'N'
      json[SHARED_KEY.LAST_GUID] = this.getGUID()
    } else {
      json = JSON.parse(jsonStr)
    }

    return json
  }

  setSetupValue(type, value) {
    if (value !== '') {
      if (value === true) {
        value = 'Y'
      }
      if (value === false) {
        value = 'N'
      }
    }
    this.shared[type] = value
    if (type === SHARED_KEY.LAST_PLAY_ID) {
      this.lastPlayID = value
    }
    // console.log("setSetupValue : " + type + "   value : " + value);
    if (type === SHARED_KEY.AUTO_PLAY && (value === 'N' || value === false)) {
      this.setSetupValue(SHARED_KEY.AUTO_PLAY_INFO, true)
    }
    this.updateSharedData()
  }

  getSetupValue(type) {
    let value = this.shared[type]
    if (value === 'Y') {
      value = true
    }
    if (value === 'N') {
      value = false
    }
    return value
  }

  updateSharedData() {
    let jsonStr = JSON.stringify(this.shared)
    Util.setStorage(this.SHARE_KEY, jsonStr)
  }

  getDefaultParam(contentType, playerMode) {
    let param = {}
    param.device = this.device
    param.partner = 'pooq'
    param.apikey = this.API_CREDENTIAL_KEY

    if (
      this.credentialKey !== null &&
      this.credentialKey !== undefined &&
      !(
        playerMode === ScalablePlayer.playerMode.INSTANT &&
        contentType === ScalablePlayer.contentType.LIVE
      )
    ) {
      param.credential = this.credentialKey
    } else {
      param.credential = 'none'
    }

    if (contentType !== ScalablePlayer.contentType.BASEBALL_LIVE) {
      param.pooqzone = this.pooqzoneType
      param.region = 'kor'
      param.drm = this.drmType
      param.targetage = 'all'
    } else {
      param.spo_itm_cd = 'KBO'
      param.IF = 'IF-NSMXPG-113'
      param.ver = '2.0'
      param.m = 'getStadiumConditionList'
    }
    return param
  }

  getDRMType() {
    let drmType = DRM_TYPE.NONE
    let name = this.browser.name.toLowerCase()
    let version = Number(this.browser.version)
    version = isNaN(version) === true ? -1 : version

    switch (name) {
      case 'firefox':
        drmType = version >= 52 ? DRM_TYPE.WIDEVINE : drmType
        break
      case 'safari':
        drmType = version >= 11 ? DRM_TYPE.FAIR_PLAY : drmType
        break
      case 'chrome':
        drmType = version >= 52 ? DRM_TYPE.WIDEVINE : drmType
        break
      case 'opera':
        drmType = version >= 15 ? DRM_TYPE.PLAY_READY : drmType
        break
      default:
        drmType = name.indexOf('ie') !== -1 ? DRM_TYPE.WIDEVINE_CLASIC : drmType
        break
    }
    return drmType
  }

  getGUID() {
    let guid = String(CryptoJS.MD5(Util.generateID('POOQ')))
    return guid
  }

  getADParam(vs, tid) {
    let param = {}
    param.version = vs
    param.media = 'SMR_MEMBER'
    param.site = 'POOQ_LIVE'
    param.tid = tid // String(CryptoJS.MD5(jarvis.lib.generateID("POOQ")));
    param.uuid = String(CryptoJS.MD5(this.GUID))
    param.ip = this.clientIP
    param.gender = '3'
    param.age = '99'
    param.platform = 'PCWEB'
    param.playertype = this.playerType
    param.os = this.osVer
    param.devicemodel = 'PC'
    param.telco = ''
    param.cpid = ''
    param.vodtype = 'O'
    param.channelid = ''
    param.category = ''
    param.section = ''
    param.programid = ''
    param.clipid = ''
    param.referrer = document.referrer
    param.adlink = ''

    return param
  }

  getADRequestParam(adRequestData, playTime) {
    if (isNull(playTime)) {
      playTime = 3600
    }

    let param = this.getADParam(adRequestData.adapiversion, adRequestData.tid)
    param.requesttime = ''
    param.contentnumber = ''
    param.targetnation = 'KR'
    param.isonair = 'Y'
    param.ispay = 'N'
    param.broaddate = ''
    param.playtime = String(playTime)
    param.starttime = ''
    param.endtime = ''
    param.adtype = 'PRE'
    param.customkeyword = ''
    param = this.overrideParam(param, adRequestData)
    param.broaddate = param.broaddate.slice(0, 8)

    return param
  }

  getMedialogParam(adRequestData, t) {
    let param = this.getADParam(adRequestData.logapiversion, adRequestData.tid)
    param.playdate = Util.getYMDHIS()
    param.trackpoint = t
    param.like = ''
    param.firstplay = 'Y'

    return this.overrideParam(param, adRequestData)
  }

  getBase64Url(source, isBookMark) {
    let encodedSource = CryptoJS.enc.Base64.stringify(source)
    if (isBookMark !== true) {
      encodedSource = encodedSource.replace(/=+$/, '')
    }
    encodedSource = encodedSource.replace(/\+/g, '-')
    encodedSource = encodedSource.replace(/\//g, '_')

    return encodedSource
  }

  getJWTString(param) {
    let header = {
      alg: 'HS256',
      typ: 'JWT',
    }
    let stringifiedHeader = CryptoJS.enc.Utf8.parse(JSON.stringify(header))
    let encodedHeader = this.getBase64Url(stringifiedHeader)
    let stringifiedData = CryptoJS.enc.Utf8.parse(JSON.stringify(param))
    let encodedData = this.getBase64Url(stringifiedData)
    let token = encodedHeader + '.' + encodedData
    let secret = this.SMR_ENC_KEY
    let signature = CryptoJS.HmacSHA256(token, secret)
    signature = this.getBase64Url(signature)
    let signedToken = token + '.' + signature
    return signedToken
  }

  overrideParam(param, adData) {
    for (let key in param) {
      if (!adData[key]) {
        let ovStr = String(adData.optionnalData[key])
        if (ovStr !== 'undefined') {
          param[key] = adData.optionnalData[key]
        }
      }
    }
    return param
  }

  setBookMarkContentID(vodObject, param) {
    if (isNull(vodObject)) {
      return
    }

    let channelType = vodObject.getChannelType()
    param.cornerId = ''
    param.channelType = channelType
    switch (channelType) {
      case 'L':
        param.contentId = ''
        param.programId = vodObject.contentID
        break
      case 'C':
        param.programId = 'CLIP'
        param.contentId = vodObject.contentID
        break
      case 'M':
        param.contentId = vodObject.contentID
        param.programId = 'MOVIE'
        break
      case 'E':
        if (vodObject.type === ScalablePlayer.contentType.BASEBALL_LIVE) {
          param.contentId = ''
          param.programId = vodObject.contentID
        } else if (
          vodObject.type === ScalablePlayer.contentType.BASEBALL_HIGHLIGHT
        ) {
          param.contentId = vodObject.contentID
          param.programId = vodObject.programID
        }
        break
      case 'V':
      default:
        param.contentId = vodObject.contentID
        param.programId = vodObject.programID
        break
    }
  }

  getBookMarkData(vodObject, playData) {
    let param = {}
    param.itemType = vodObject.getItemType()
    param.userNo = this.userNo
    param.profileId = this.profileID
    param.playId = this.lastPlayID
    param.guid = this.GUID
    if (isNull(param.userNo)) {
      param.userNo = 'NOLOGIN'
    }

    this.setBookMarkContentID(vodObject, param)
    param.deviceType = '1'
    param.ipAddress = this.clientIP
    if (isNull(param.ipAddress)) {
      param.ipAddress = '127.0.0.0'
    }
    param.concurrencyGroup = vodObject.concurrencyGroup
    param.issue = vodObject.issue
    param.isCharged = vodObject.chargedType
    param.priceType = vodObject.priceType
    param.pooqzoneType = this.pooqzoneType !== 'none' ? 'P01' : ''

    let extra = this.getExtraData(vodObject, playData)
    if (extra !== null && extra !== undefined && extra !== '') {
      param.extra = extra
    }

    return param
  }

  getBookMarkDataForChromecast(vodObject) {
    let param = {}

    param.itemType = vodObject.getItemType()
    param.userNo = this.userNo
    param.profileId = this.profileID
    param.playId = this.lastPlayID
    param.guid = this.GUID
    if (isNull(param.userNo)) {
      param.userNo = 'NOLOGIN'
    }

    this.setBookMarkContentID(vodObject, param)
    param.deviceType = '1'
    param.ipAddress = this.clientIP
    if (isNull(param.ipAddress)) {
      param.ipAddress = '127.0.0.0'
    }
    param.concurrencyGroup = vodObject.concurrencyGroup
    param.issue = vodObject.issue
    param.isCharged = vodObject.chargedType
    param.priceType = vodObject.priceType
    param.pooqzoneType = this.pooqzoneType !== 'none' ? 'P01' : ''
    if (!isNull(vodObject.extraItem)) {
      param.extraItem = vodObject.extraItem
    }
    if (!isNull(vodObject.bookmarkExtra)) {
      param.bookmarkExtra = vodObject.bookmarkExtra
    }

    return param
  }

  getLogTime(time) {
    let ta = String(time).split('.')
    return Util.getTimeStr(ta[0], ':', true)
  }

  getNowLogDate() {
    let now = new Date()
    let tzoneOffSet = Number(now.getTimezoneOffset())
    let tzoneT = Math.floor(tzoneOffSet / 60)
    let tzoneM = tzoneOffSet % 60
    let tzoneStr =
      Util.intToText(Math.abs(tzoneT), 2) + Util.intToText(tzoneM, 2)
    tzoneStr = tzoneOffSet < 0 ? '+' + tzoneStr : (tzoneStr = '-' + tzoneStr)

    let d =
      now.getFullYear() +
      '-' +
      Util.intToText(now.getMonth() + 1, 2) +
      '-' +
      Util.intToText(now.getDate(), 2) +
      ' ' +
      Util.intToText(now.getHours(), 2) +
      ':' +
      Util.intToText(now.getMinutes(), 2) +
      ':' +
      Util.intToText(now.getSeconds(), 2) +
      tzoneStr
    return d
  }

  getExtraData(vodObject, playData) {
    let extra = {}
    if (isNull(playData) || isNull(playData.errorCode)) {
      extra.osV = this.osVer
      extra.appV = ScalablePlayer.Version
      extra.apiV = '3'
      extra.deviceName = this.deviceName4Bookmark
      extra.playerType = playData.playerType
      console.log('DataInfo-getExtraData: vodObject=' + (vodObject == null))

      if (vodObject !== null && vodObject !== undefined) {
        if (
          vodObject.extraItem !== null &&
          vodObject.extraItem !== undefined &&
          vodObject.extraItem !== '' &&
          vodObject.extraItem !== 'none'
        ) {
          console.log(
            'DataInfo-getExtraData: vodObject.extraItem=' + vodObject.extraItem,
          )
          extra.extraitem = vodObject.extraItem
        }

        if (
          vodObject.bookmarkExtra !== null &&
          vodObject.bookmarkExtra !== undefined &&
          vodObject.bookmarkExtra !== ''
        ) {
          for (let key in vodObject.bookmarkExtra) {
            extra[key] = vodObject.bookmarkExtra[key]
          }
        }

        if (vodObject.type === ScalablePlayer.contentType.BASEBALL_HIGHLIGHT) {
          extra.mediaType = 'BH'
        } else if (
          vodObject.type === ScalablePlayer.contentType.BASEBALL_LIVE
        ) {
          extra.mediaType = 'BL'
        }
      }
    } else {
      console.log('DataInfo-getExtraData: errorCode=' + playData.errorCode)
      extra.errorCode = playData.errorCode
      extra.osVer = this.osVer
      extra.appVer = ScalablePlayer.Version
      extra.drmType = vodObject.drmType
      extra.deviceName = this.deviceName4Applog
      extra.deviceTypeId = '1'
      extra.networkType = '0'
      extra.playerType = playData.playerType
      extra.isAllow = vodObject.isAllow === true ? 'Y' : 'N'
    }
    return extra
  }

  /* checkApiResult (returnData, xhrStatus) {
        if (isNull(returnData)) {
            return new APIResultObject(API_RESULT.API_ERROR, API_RESULT_MSG.SERVER_ERROR)
        }
        if (isNull(returnData.resultcode)) {
            return new APIResultObject(API_RESULT.SUCCESS)
        }
        let result = new APIResultObject(returnData.resultcode, this.jsonEscape(returnData.resultmessage), returnData.resultoptional)
        if (xhrStatus === API_RESULT.API_RETRY) {
            return this.retryApiResult(result)
        }
        return result
    }

    retryApiResult (result) {
        switch (result.code) {
            case '303':
                if (window.reLoginProc) window.reLoginProc()
                return new APIResultObject(API_RESULT.API_ERROR, API_RESULT_MSG.SERVER_ERROR)
        }
        return result
    } */

  setAdultVerification(adultVerification) {
    if (typeof adultVerification === 'string') {
      let firstBar = 4 // adultVerification.indexOf("-");
      let secondBar = 7 // adultVerification.indexOf("-", firstBar + 1);
      let year = Number(adultVerification.substring(0, firstBar))
      let month = Number(adultVerification.substring(firstBar + 1, secondBar))
      let day = Number(
        adultVerification.substring(secondBar + 1, adultVerification.length),
      )

      if (this.adultVerification == null) {
        this.adultVerification = new Date(year, month, day)
      } else {
        this.adultVerification.setFullYear(year)
        this.adultVerification.setMonth(month)
        this.adultVerification.setDate(day)
      }
    } else {
      this.adultVerification.setFullYear(adultVerification.year)
      this.adultVerification.setMonth(adultVerification.month)
      this.adultVerification.setDate(adultVerification.day)
    }
  }

  getAdultVerification() {
    return this.adultVerification
  }
  checkSupportEAC3() {
    const audio = new Audio()
    return audio.canPlayType('audio/mp4; codecs="ec-3"') !== ''
  }
  checkSupportHEVC() {
    const video = document.createElement('video')
    return video.canPlayType('video/mp4; codecs="hev1.1.6.L93.B0"') !== ''
  }
}

export default {
  PlayInfoObj: PlayInfoObj,
  MetaObj: MetaObj,
  DataInfo: DataInfo,
  Util: Util,
}
